import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SelectSearchLegacyComponent } from './components/select-search-legacy/select-search-legacy.component';
import { SelectSearchComponent } from './components/select-search/select-search.component';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
    declarations: [SelectSearchLegacyComponent, SelectSearchComponent],
    imports: [CommonModule, MatFormFieldModule, MatSelectModule, ReactiveFormsModule, NgxMatSelectSearchModule, FontAwesomeModule, ScrollingModule, MatTooltipModule, MatButtonModule, MatIconModule],
    exports: [SelectSearchLegacyComponent, SelectSearchComponent, SelectSearchComponent],
    // exports: [SelectSearchComponent],
})
export class SelectSearchModule {}
